import { render } from "./DropDownListBibFormaAquisicao.vue?vue&type=template&id=94eff960&ts=true"
import script from "./DropDownListBibFormaAquisicao.vue?vue&type=script&lang=ts"
export * from "./DropDownListBibFormaAquisicao.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__